import { useRouter } from 'next/router'
import styles from './styles.module.scss'
import { Button } from '@components/ui/Button'
import { analytics } from '@helpers/analytics'
import Carousel from '@components/ui/Carousel'
import { ACCOUNT_ANALYTICS_EVENT_LABEL_NAMES } from '@components/account/AccountWrapper'
import LoginLink from '../LoginLink'
import { prefixLocale } from '@helpers/env'

export default function Navigation() {
  const router = useRouter()

  const handleClick = (path: string, label: string) => {
    analytics('Click', {
      category: 'Account Nav',
      label:
        ACCOUNT_ANALYTICS_EVENT_LABEL_NAMES[
          path as keyof typeof ACCOUNT_ANALYTICS_EVENT_LABEL_NAMES
        ]
    })

    const trimmedLabel = label.replace(/\s/g, '-')?.toLowerCase()
    router.push(
      {
        href: `${prefixLocale()}/account?page=${trimmedLabel}`,
        query: { page: trimmedLabel }
      },
      `${prefixLocale()}/account?page=${trimmedLabel}`,
      {
        scroll: false,
        shallow: true
      }
    )
  }

  const pageHande = router.query?.page as string

  const isActive = (label: string) =>
    pageHande
      ?.toLowerCase()
      .includes(`${label?.trim().replace(/\s/g, '-')?.toLowerCase()}`) ||
    (!pageHande && label === 'Overview' && router?.asPath?.includes('/account'))

  const activeNavigationIndex = Object.entries(
    ACCOUNT_ANALYTICS_EVENT_LABEL_NAMES
  ).findIndex(([key]) => router.asPath.includes(`${key?.toLowerCase()}`))

  const carouselSettings = {
    infinite: false,
    loop: false,
    slidesToScroll: 2,
    startIndex: activeNavigationIndex - 1
  }

  return (
    <nav className={styles.Navigation} aria-labelledby="account-navigation">
      <Carousel settings={carouselSettings}>
        {Object.entries(ACCOUNT_ANALYTICS_EVENT_LABEL_NAMES).map(
          ([path, label]) => (
            <Button
              key={path}
              onClick={() => handleClick(path, label)}
              variant="secondary"
              fullWidth="inherit"
              selected={isActive(label)}
              classes={`${styles.NavigationItem} ${
                isActive(label) ? styles.NavigationItem__selected : ''
              }`}
            >
              {label}
            </Button>
          )
        )}
      </Carousel>
      <div className={styles.Navigation__logout}>
        <LoginLink />
      </div>
    </nav>
  )
}
